import { FlashFilled } from '@carbon/icons-react';
import { Sparkle } from '@routable/ai';
import { TruncatableText } from '@routable/components';
import { Tooltip } from '@routable/gross-ds';
import clsx from 'clsx';
import React from 'react';
import { useOverlaysSourceForFieldValue } from 'hooks';
const SelectLabel = ({ isFocused, isRequired, label, name }) => {
    const { currentSource, isPredictiveCodingUiEnabled } = useOverlaysSourceForFieldValue(name);
    return (React.createElement("label", { className: clsx('select--label inline-flex items-baseline gap-2', {
            focused: !!isFocused,
            'max-w-[calc(100%-32px)]': !currentSource,
            'max-w-[calc(100%-44px)]': !!currentSource,
        }), htmlFor: name },
        currentSource && (React.createElement(Tooltip, { "data-testid": `source-tooltip-${name}`, tooltip: isPredictiveCodingUiEnabled && currentSource, variant: "dark" }, isPredictiveCodingUiEnabled ? (React.createElement(Sparkle, { size: 12 })) : (React.createElement(FlashFilled, { className: "text-magenta-50", size: 12, title: "OCR" })))),
        React.createElement(TruncatableText, { position: "top", text: label }),
        isRequired && (React.createElement("span", { className: "text-blue-40 pl-1", "data-testid": `${name}:required` }, "*"))));
};
export default SelectLabel;
